import { DecoratorResult } from '../types/decorator-result.mjs';

function optionNameDecorator(productOption, i18n) {
    const result = new DecoratorResult();
    if (productOption.key === "Quantity") {
        result.addMutation({
            type: "update",
            reason: "quantity should use translations of quantityLabel as name",
            oldState: productOption.name,
            newState: i18n("quantityLabel"),
        });
        productOption.name = i18n("quantityLabel");
    }
    return result;
}

export { optionNameDecorator };
//# sourceMappingURL=option-name-decorator.mjs.map
